import React from "react";
import { useDeviceType } from "../../../../components/customHooks/useDeviceType";
import "./profile.m.css";

const Profile = ({
  image,
  name,
  role,
  isSpeakerProfile = false,
  divider = false,
  imageWidth,
  imageHeight,
  isFireSideProfile,
}) => {
  const isMobile = useDeviceType() !== "desktop";
  const defaultImageStyle = { backgroundImage: `url(${image}?w=320&auto=format,compress&fit=max&q=70)` };
  imageWidth && (defaultImageStyle.width = imageWidth);
  imageHeight && (defaultImageStyle.height = imageHeight);
  const speakerStyles = isSpeakerProfile
    ? isMobile
      ? { backgroundImage: `url(${image}?w=320&auto=format,compress&fit=max&q=70)`, height: "auto" }
      : { backgroundImage: `url(${image}?w=320&auto=format,compress&fit=max&q=70)`, height: "250px" }
    : defaultImageStyle;

  const firesideImageStyles = isMobile
    ? { backgroundImage: `url(${image}?w=320&auto=format,compress&fit=max&q=70)`, width: "auto" }
    : { backgroundImage: `url(${image}?w=320&auto=format,compress&fit=max&q=70)`, height: "284px" };

  console.log("firesideImageStyles:", firesideImageStyles, defaultImageStyle);

  return isFireSideProfile ? (
    <>
      <div styleName="fireside-profile">
        <div styleName="fire-side-image" style={firesideImageStyles}></div>
        <div styleName="fireside-frame">
          <div styleName="fireside-title">{name}</div>
          <p styleName="fireside-role">{role}</p>
        </div>
      </div>
      {divider && <div styleName="divider" />}
    </>
  ) : (
    <>
      <div styleName={`${isSpeakerProfile ? "small-profile-speakers-winner" : "speakers-winner"}`}>
        <div styleName={`image`} style={speakerStyles}></div>
        <div styleName="frame">
          <div styleName={`${isSpeakerProfile ? "small-profile-heading-sam-altman" : "heading-sam-altman"}`}>
            {name}
          </div>
          <p styleName={`${isSpeakerProfile ? "small-profile-text-wrapper" : "text-wrapper"}`}>{role}</p>
        </div>
      </div>
      {divider && <div styleName="divider" />}
    </>
  );
};

export default Profile;
